interface VideoInterface {

};

export const initVideoBlock = ( el: HTMLElement ): VideoInterface => {
	const Object = {
		config: {
			allowFullScreen: el.dataset.videoAllowFullscreen === 'true',
		},
		state: {
			isMuted: el.dataset.videoMuted === 'true',
			isLoop: el.dataset.videoLoop === 'true',
			isPaused: el.dataset.videoAutoplay === 'false',
			volume: Number( el.dataset.videoVolume ) * 0.01,
		},
		container: el,
		fullscreenButtonEl: null as HTMLButtonElement | null,
		muteButtonEl: null as HTMLButtonElement | null,
		pauseButtonEl: el.querySelector('.video__control--pause') as HTMLButtonElement,
		playButtonEl: el.querySelector('.video__control--play') as HTMLButtonElement,
		videoEl: el.querySelector('.video__player') as HTMLVideoElement,


		_init(): void {
			console.log( 'Init Video: ', this.container );

			this._bindClass();
			this._bindEvents();
			this.setupVideo();
		},

		_bindClass(): void {
			this.pauseVideo = this.pauseVideo.bind(this);
			this.playVideo = this.playVideo.bind(this);
			this.toggleMute = this.toggleMute.bind(this);
			this.toggleFullscreen = this.toggleFullscreen.bind(this);
		},

		_bindEvents(): void {
			this.fullscreenButtonEl?.addEventListener('click', this.toggleFullscreen);
			this.muteButtonEl?.addEventListener('click', this.toggleMute);
			this.pauseButtonEl?.addEventListener('click', this.pauseVideo);
			this.playButtonEl?.addEventListener('click', this.playVideo);
		},

		pauseVideo(): void {
			if (this.videoEl) {
				this.videoEl.pause();
				this.videoEl.controls = false;

				if (this.container) {
					this.container.classList.remove('video--play');
					this.container.classList.add('video--paused');
				}
			}
		},

		playVideo(): void {
			if (this.videoEl) {
				this.videoEl.play();
				this.videoEl.controls = true;

				if (this.container) {
					this.container.classList.remove('video--paused');
					this.container.classList.add('video--play');
				}
			}
		},

		setupVideo(): void {
			if ( ! this.config.allowFullScreen ) {
				this.videoEl.setAttribute('controlslist', 'nofullscreen');
				this.videoEl.setAttribute('playsinline', 'true');
			}

			this.videoEl.volume = this.state.volume;
			this.videoEl.muted = this.state.isMuted;
			this.videoEl.loop = this.state.isLoop;
			this.videoEl.autoplay = !this.state.isPaused;
		},

		toggleFullscreen(): void {
			if (this.container) {
				this.container.classList.toggle('video--fullscreen');
			}
		},

		toggleMute(): void {
			if (this.videoEl) {
				this.videoEl.muted = !this.videoEl.muted;
			}
		},
	};

	Object._init();
	return Object;
}

export const initVideoBlocks = ( selectors = '.video' ): void => {
	const blocks = document.querySelectorAll( selectors ) as NodeListOf<HTMLElement>;

	blocks.forEach(
		( el: HTMLElement ) => initVideoBlock( el )
	);
}
